import Vue from "vue";
import VueRouter from "vue-router";
import goTo from "vuetify/es5/services/goto";
import Home from "../views/Home.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    component: Home,
    meta: {
      title: "Zoe Estates Ltd",
    },
  },
  {
    path: "/landlord",
    name: "landlord",
    meta: {
      title: "Landlords & Estate Agents - Zoe Estates Ltd",
    },
    component: () => import("../views/Landlord"),
  },
  {
    path: "/investors",
    name: "investors",
    meta: {
      title: "Investors - Zoe Estates Ltd",
    },
    component: () => import("../views/Investors"),
  },
  {
    path: "/corporate-housing",
    name: "corporate-housing",
    meta: {
      title: "Corporate Housing - Zoe Estates Ltd",
    },
    component: () => import("../views/CorporateHousing"),
  },
  {
    path: "/room-let-housing",
    name: "room-let-housing",
    meta: {
      title: "Room Let Housing (HMO): Zoe Estates Ltd",
    },
    component: () => import("../views/RoomLetHousing"),
  },
  {
    path: "/services",
    name: "services",
    meta: {
      title: "Services - Zoe Estates Ltd",
    },
    component: () => import("../views/Service"),
  },
  {
    path: "/work-with-us",
    name: "work-with-us",
    meta: {
      title: "Why Work with us: Zoe Estates Ltd",
    },
    component: () => import("../views/WorkWithUs"),
  },
  {
    path: "/register-property",
    name: "register-property",
    meta: {
      title: "Register your property: Zoe Estates Ltd",
    },
    component: () => import("../views/RegisterProperty"),
  },
  {
    path: "/contact-us",
    name: "contact-us",
    meta: {
      title: "Contact us: Zoe Estates Ltd",
    },
    component: () => import("../views/Contact"),
  },
];
const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
  scrollBehavior: (to, from, savedPosition) => {
    let scrollTo = { target: ".app-main", offset: 200 };
    if (to.hash) {
      scrollTo.target = to.hash;
    } else if (savedPosition) {
      scrollTo.target = savedPosition.y;
    }
    if (to.path == "/") {
      return goTo(0);
    } else {
      return goTo(scrollTo.target, { offset: scrollTo.offset });
    }
  },
});

router.beforeEach((to, from, next) => {
  document.title = to.meta.title;
  next();
});

export default router;
